import weddingsRootUrl from '@api/helpers/weddingsRootUrl';

const resolvedWeddingsRootUrl = weddingsRootUrl();

const get = (opts) => {
	const { weddingId, sessionToken } = opts;
	// global fetch
	return fetch(
		`${resolvedWeddingsRootUrl}/weddings/${weddingId}/saved_vendors?api_key=${process.env.WEDDINGS_API_KEY}`,
		{
			method: 'GET',
			headers: {
				'MEMBERSHIP-SESSION-TOKEN': sessionToken,
			},
		},
	).then((res) => res.json());
};

const create = (opts) => {
	const { weddingId, data, sessionToken } = opts;
	return fetch(
		`${resolvedWeddingsRootUrl}/weddings/${weddingId}/saved_vendors?api_key=${process.env.WEDDINGS_API_KEY}`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'MEMBERSHIP-SESSION-TOKEN': sessionToken,
			},
			body: JSON.stringify(data),
		},
	).then(async (res) => {
		if (!res.ok) {
			const error = new Error(`HTTP error: ${res.status}`);
			error.status = res.status;
			try {
				error.body = res.status < 500 ? await res.json() : null;
			} catch (e) {}
			throw error;
		}
		return res.json();
	});
};

const destroyByObjectId = (opts) => {
	const { weddingId, savedVendorId, sessionToken } = opts;
	return fetch(
		`${resolvedWeddingsRootUrl}/weddings/${weddingId}/saved_vendors?api_key=${process.env.WEDDINGS_API_KEY}`,
		{
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				'MEMBERSHIP-SESSION-TOKEN': sessionToken,
			},
			body: JSON.stringify({ saved_vendor_ids: [savedVendorId] }),
		},
	);
};

export default {
	get,
	create,
	destroyByObjectId,
};
